import {
    Container,
    Tabs,
    Tab,
    Box,
    Dialog,
    IconButton,
    List,
    MenuItem,
    Typography,
    Pagination,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import { OfferHistory } from "../../../../explorer/types/Basket/OfferHistory";
import ServiceProvider from "../../../configuration/ServiceProvider";
import {
    AppIconsClose,
    AppIconsOffer,
    AppIconsOrder,
    AppIconsOrderOffer,
} from "../../../components/AppIcons";
import {
    Content,
    PageTitle,
    Root,
    StyledCommonDialog,
    TabsComponentStyled,
    useClasses,
} from "./OfferOrder.style";
import AppCustomTabPanel from "../../../components/AppTabPanel/AppCustomTabPanel";
import PartList, {
    ColumnAlign,
    ColumnWidth,
    TColumns,
} from "../../../components/PartsList/PartList";
// import Pagination from "./Pagination";
import OfferOrderStatusIconComponent from "../../../components/Basket/upload/OfferOrderStatusIconComponent";
import OfferOrderConditionsComponent from "../../../components/Basket/upload/OfferOrderConditionsComponent";
import OfferOrderNoteIconComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/OfferOrderNoteIconComponent";
import useBrands from "../../../../explorer/hooks/useBrands";
import { Filters } from "./Filters";
import { OrderHistory } from "../../../../explorer/types/Basket/OrderHistory";
import OrderTypeIconComponent from "../../../components/Basket/upload/OrderTypeIconComponent";
import DateComponent from "../../../components/Basket/upload/DateComponent";
import OfferOrderDetailsProps from "../../../components/Basket/OrderOffer/OfferOrderDetailsProps";
import OfferOrderDetailsPage from "../../../components/Basket/OrderOffer/OfferOrderDetailsPage";
import { OfferHistoryResponse } from "../../../../explorer/types/Basket/OfferHistoryResponse";
import { OrderHistoryResponse } from "../../../../explorer/types/Basket/OrderHistoryResponse";
import { OrderOfferHistoryFilter } from "./OrderOfferHistoryFilter";
import { OrderOfferAddPartsToBasket } from "./OrderOfferAddPartsToBasket";
import { CreateBasketDialog } from "../../../components/AppLayout/AppHeader/AppBasketMenu/BasketListCreateDialog";
import { useBasket } from "../../../hook/useBasket";
import { CommonSnackbar } from "../../../../explorer/components/SnackBar/CommonSnackbar";
import { OrderDetailsResponse } from "../../../../explorer/types/Basket/OrderDetailsResponse";
import { OrderDetailPart } from "../../../../explorer/types/Basket/OrderDetailPart";
import { OfferDetailPart } from "../../../../explorer/types/Basket/OfferDetailPart";
import {
    OrderFromOfferDTO,
    OfferDetailsResponse,
} from "../../../../explorer/types/Basket/OfferDetailsResponse";
import { OfferOrderDetailsRequest } from "../../../../explorer/types/Basket/OfferOrderDetailsRequest";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import { Basket } from "../../../../explorer/types";
import {
    BasketItem,
    BasketItemDTO,
} from "../../../../explorer/types/Basket/BasketItems";
import { useApiError } from "../../../hook/useApiError";
import { useApiNotification } from "../../../hook/useApiNotification";
import { formatDateByLocale } from "../../../../explorer/helpers/CommonHelper";
import { DialogTitleStyled } from "../../../components/PartDetails/DrawerPart/DrawerPartDetails.styles";
import { DialogContentStyled } from "../../BasketPage/BasketPage.styles";
import BreadcrumbComponent from "../../../components/Breadcrumb/BreadcrumbComponent";
import axios, { CancelTokenSource } from "axios";
import useCurrentSite from "../../../hook/useCurrentSite";
import { BasketOfferOrderDialog } from "../../../components/Basket/OrderOffer/BasketOfferOrderDialog";
import { useTrackingOrderOffer } from "../../../hook/useTrackingOrderOffer";
import PriceFormatComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/PriceFormatComponent";
import { OfferOrderSortingType } from "../../../../explorer/types/Basket/OfferOrderSortingType";
import { AvailabilityPartResponseDTO } from "../../../../explorer/types/Basket/AvailabilityRequest";
import { ProgressPopup } from "../../../../explorer/components/ProgressPopup/ProgressPopup";
import OfferOrderWarrantyTypeIconComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/OfferOrderWarrantyTypeIconComponent";
import { useApiWarning } from "../../../hook/useApiWarning";
import AddBasketItemsWarning from "../../../components/Basket/AddBasketItemsWarning";

const OfferOrderPage = () => {
    const [value, setValue] = useState<number>(-1);
    const classes = useClasses();
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [dialogLoading, setDialogLoading] = useState<boolean>(true);
    const [currentSite, setCurrentSite] = useCurrentSite();
    const [page, setPage] = useState<number>(1);
    const [totalOfferItems, setTotalOfferItems] = useState<number>(0);
    const [totalOrderItems, setTotalOrderItems] = useState<number>(0);
    const itemsPerPage = 50;
    const [error, setError] = useApiError();
    const brand = useBrands().currentBrandUrl;
    const [notification, setNotification] = useApiNotification();
    const [warning, setWarning] = useApiWarning();
    const [accordionExpanded, setAccordionExpanded] = useState(false);
    const [offers, setOffers] = useState<OfferHistory[]>([]);
    const [orders, setOrders] = useState<OrderHistory[]>([]);
    const [dialogProps, setDialogProps] = useState<OfferOrderDetailsProps>({
        open: false,
        offerCode: "",
        orderCode: "",
        orderType: "",
        customerOfferCode: "",
        customerOrderCode: "",
    });
    // const [offerOrderCustomerReference, setOfferOrderCustomerReference] = useState<string>("");
    const [totalPages, setTotalPages] = useState<number>(1);
    const currentLanguage = useLanguages().currentLanguage;
    const [details, setDetails] = useState<
        OfferDetailsResponse | OrderDetailsResponse
    >();
    const [parts, setParts] = useState<OfferDetailPart[] | OrderDetailPart[]>();

    const [itemsForOrder, setItemsForOrder] = useState<BasketItem[]>();
    const [pricesForOrder, setPricesForOrder] = useState({});
    const [propsForOrder, setPropsForOrder] = useState<OrderFromOfferDTO>();

    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [existingDialogOpen, setExistingDialogOpen] = useState(false);
    const [basketsList] = useReduxState<Basket[]>(
        reduxStoreConfig.basketBaskets
    );

    const trackingOfferHook = useTrackingOrderOffer();
    const basketOperation = useBasket();
    const [
        basketActionResultSnackbarState,
        setBasketActionResultSnackbarState,
    ] = useState({ open: false, isError: false, message: "" });
    const [progressPopupOpen, setProgressPopupOpen] = useState(false);

    const [filters, setFilters] = useState<Filters>({
        filterStatus: undefined,
        filterCreateDateStart: undefined,
        filterCreateDateStop: undefined,
        filterPartNumber: undefined,
        sortingType: OfferOrderSortingType.CreateDateDesc,
        offerCode: undefined,
        orderCode: undefined,
        customerOfferCode: undefined,
        customerOrderCode: undefined,
        customerReference: undefined,
    });
    const CancelToken = axios.CancelToken;
    const cancelSource = useRef<CancelTokenSource>();
    const customerCode = currentSite.customerCode;

    const orderHistoryEnabled =
      currentSite?.permissions?.canAccessOrderHistory ||
      currentSite?.permissions?.canAccessServiceOrderHistory === true;
    const offerHistoryEnabled = currentSite?.permissions?.canAccessOfferHistory;

    const fetchDetails = async (
        offerCode: string,
        orderCode: string,
        orderType: string,
        customerOfferCode: string,
        customerOrderCode: string
    ) => {
        if (
            (!offerCode &&
                !orderCode &&
                !customerOfferCode &&
                !customerOrderCode) ||
            customerCode === undefined
        )
            return;

        const requestData = {
            sellingCompanyCode: brand.toUpperCase(),
            customerCode: customerCode,
            currentLanguage: currentLanguage,
            offerCode: offerCode || "",
            orderCode: orderCode || "",
            orderType: orderType || "",
            customerOfferCode: customerOfferCode || "",
            customerOrderCode: customerOrderCode || "",
        };

        try {
            if (cancelSource.current) {
                const result =
                    orderCode || customerOrderCode
                        ? await ServiceProvider.OfferOrder.getOrderDetails(
                              requestData,
                              cancelSource.current
                          )
                        : await ServiceProvider.OfferOrder.getOfferDetails(
                              requestData,
                              cancelSource.current
                          );

                setDetails(result);
                setParts(result?.parts || []);
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setDialogLoading(false);
        }
    };

    const updateFilters = (newFilters: Partial<typeof filters>) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ...newFilters,
        }));
        setPage(1);
    };

    const handleOpenOfferOrderDetails = (
        offerCode: string,
        orderCode: string,
        orderType: string,
        customerOfferCode: string,
        customerOrderCode: string
    ) => {
        setDialogLoading(true);
        setDialogProps({
            offerCode,
            orderCode,
            orderType,
            customerOfferCode,
            customerOrderCode,
            open: true,
        });
    };

    useEffect(() => {
          var myValue =
        orderHistoryEnabled === true ? 0 : offerHistoryEnabled === true ? 1 : false;
      if (myValue !== false) setValue(myValue);
    }, [customerCode]);

    useEffect(() => {

        if (dialogProps.open) {
            setDetails(undefined);
            setParts([]);
            cancelSource.current = CancelToken.source();
            fetchDetails(
                dialogProps.offerCode ?? "",
                dialogProps.orderCode ?? "",
                dialogProps.orderType ?? "",
                dialogProps.customerOfferCode ?? "",
                dialogProps.customerOrderCode ?? ""
            );
        }

        return () => {
            cancelSource.current?.cancel();
        };
    }, [dialogProps.open]);

    const fetchData = async () => {
        if (customerCode !== undefined && value >= 0) {
            const isOrderTab = value === 0;

            const request = isOrderTab
                ? {
                      sellingCompanyCode: brand.toUpperCase(),
                      customerCode: customerCode,
                      filterStatus: filters.filterStatus,
                      filterCreateDateStart:
                          filters.filterCreateDateStart?.replaceAll("-", ""),
                      filterCreateDateStop:
                          filters.filterCreateDateStop?.replaceAll("-", ""),
                      filterPartNumber: filters.filterPartNumber,
                      filterOrderCode: filters.orderCode,
                      filterCustomerOrderCode: filters.customerOrderCode,
                      filterCustomerReference: filters.customerReference,
                      sortingType: filters.sortingType,
                      paginationItemsPerPage: itemsPerPage,
                      paginationPage: page,
                      filterOrderType: filters.filterOrderType,
                  }
                : {
                      sellingCompanyCode: brand.toUpperCase(),
                      customerCode: customerCode,
                      filterStatus: filters.filterStatus,
                      filterCreateDateStart:
                          filters.filterCreateDateStart?.replaceAll("-", ""),
                      filterCreateDateStop:
                          filters.filterCreateDateStop?.replaceAll("-", ""),
                      filterPartNumber: filters.filterPartNumber,
                      filterOfferCode: filters.offerCode,
                      filterCustomerOfferCode: filters.customerOfferCode,
                      filterCustomerReference: filters.customerReference,
                      sortingType: filters.sortingType,
                      paginationItemsPerPage: itemsPerPage,
                      paginationPage: page,
                  };

            try {
                setLoading(true);
                const response = isOrderTab
                    ? await ServiceProvider.OfferOrder.getOrderHistory(request)
                    : await ServiceProvider.OfferOrder.getOfferHistory(request);

                if (isOrderTab && (response as OrderHistoryResponse)) {
                    setOrders((response as OrderHistoryResponse).orders);
                    setTotalOrderItems(response.totalItemsCount);
                } else {
                    setOffers((response as OfferHistoryResponse).offers);
                    setTotalOfferItems(response.totalItemsCount);
                }
            } catch (err: any) {
                setError(err.message || "Errore durante il recupero dei dati");
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        setPage(1);
        fetchData();
    }, [customerCode, value, filters]);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setPage(1);
        setFilters({
            filterStatus: undefined,
            filterCreateDateStart: undefined,
            filterCreateDateStop: undefined,
            filterPartNumber: undefined,
            sortingType: OfferOrderSortingType.CreateDateDesc,
            offerCode: undefined,
            orderCode: undefined,
            customerOfferCode: undefined,
            customerOrderCode: undefined,
            customerReference: undefined,
        });
        setValue(newValue);
    };

    useEffect(() => {
        const pages = Math.max(
            1,
            Math.ceil(
                (value === 0 ? totalOrderItems : totalOfferItems) / itemsPerPage
            )
        );
        setTotalPages(pages);
    }, [totalOfferItems, totalOrderItems, itemsPerPage, value]);

    const getColumns: (tabValue: number) => TColumns[] = (tabValue: number) =>
        tabValue === 0
            ? [
                  {
                      name: "customerReference",
                      viewHeader: true,
                      width: ColumnWidth.ShortTextWidth,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "customerOrderCode",
                      viewHeader: true,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "orderCode",
                      viewHeader: true,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "orderStatus",
                      viewHeader: true,
                      customComponent: OfferOrderStatusIconComponent,
                      additionalProps: false,
                      align: ColumnAlign.Center,
                  },
                  {
                      name: "orderType",
                      viewHeader: true,
                      customComponent: OrderTypeIconComponent,
                      additionalProps: false,
                      align: ColumnAlign.Center,
                  },
                  {
                      name: "orderDate",
                      viewHeader: true,
                      customComponent: DateComponent,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "deliveryDate",
                      viewHeader: true,
                      customComponent: DateComponent,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "conditions",
                      viewHeader: true,
                      customComponent: OfferOrderConditionsComponent,
                      align: ColumnAlign.Center,
                  },
                  //   {
                  //       name: "warrantyOrderType",
                  //       headerText: t("offerOrder.WarrantyOrderType"),
                  //       viewHeader: true,
                  //       customComponent: OfferOrderWarrantyTypeIconComponent,
                  //       align: ColumnAlign.Center,
                  //       useHeaderTooltip: true,
                  //   },
                  {
                      name: "note",
                      viewHeader: true,
                      customComponent: OfferOrderNoteIconComponent,
                      align: ColumnAlign.Center,
                  },
                  {
                      name: "netTotalAmount",
                      viewHeader: true,
                      customComponent: PriceFormatComponent,
                      align: ColumnAlign.Left,
                  },
              ]
            : [
                  {
                      name: "customerReference",
                      viewHeader: true,
                      width: ColumnWidth.ShortTextWidth,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "customerOfferCode",
                      viewHeader: true,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "offerCode",
                      viewHeader: true,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "offerStatus",
                      viewHeader: true,
                      customComponent: OfferOrderStatusIconComponent,
                      align: ColumnAlign.Center,
                  },
                  {
                      name: "offerRequestDate",
                      viewHeader: true,
                      customComponent: DateComponent,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "offerExpirationDate",
                      viewHeader: true,
                      customComponent: DateComponent,
                      align: ColumnAlign.Left,
                  },
                  {
                      name: "conditions",
                      viewHeader: true,
                      customComponent: OfferOrderConditionsComponent,
                      align: ColumnAlign.Center,
                  },
                  {
                      name: "note",
                      viewHeader: true,
                      customComponent: OfferOrderNoteIconComponent,
                      align: ColumnAlign.Center,
                  },
                  {
                      name: "netTotalAmount",
                      viewHeader: true,
                      customComponent: PriceFormatComponent,
                      align: ColumnAlign.Left,
                  },
              ];

    const handleAddToExistingCart = (code: string) => {
        setExistingDialogOpen(true);
    };
    const handleAddToNewCart = (code: string) => {
        setCreateDialogOpen(true);
    };

    const addItemsToBasket = (items: BasketItemDTO[]) => {
        ServiceProvider.Basket.AddBasketItems(items)
        .then((result) => {
           if (result && result.warning === true) {
                setWarning(<AddBasketItemsWarning apiResult={result}></AddBasketItemsWarning>);    
           } else {
            setNotification(t("common.basket.itemsAddedSelectedBasket"));
           }
        })
        .catch((errors) => {
            if (errors)
                setError(
                    errors.map((e: { errorCode: string | undefined }) =>
                        t(`basket.items.${e.errorCode}`)
                    )
                );
            else setError(t("basket.genericError"));
        });
    };

    const getItems = (basket: Basket) => {
        if (parts) {
            var items = trackingOfferHook.mapPartsToBasketItems(
                parts,
                basket.id!
            );
            return items;
        }
        return [];
    };

    const handleCreateBasketConfirm = async (name: string) => {
        const result = await basketOperation.createBasket(name);
        if (result && result.isError !== true) {
            const newBasket: Basket = result.result.find(
                (x: { name: string }) => x.name === name
            )!;
            var items = getItems(newBasket);
            addItemsToBasket(items);
            //setNotification(t("common.basket.itemsAddedNewBasket"));
        }
        setCreateDialogOpen(false);
        //setBasketActionResultSnackbarState(result);
    };

    const handleBasketSelect = (basket: Basket) => {
        var items = getItems(basket);
        addItemsToBasket(items);
        //setNotification(t("common.basket.itemsAddedSelectedBasket"));
        setExistingDialogOpen(false);
    };

    const handleDialogClose = () => {
        setDialogProps({
            open: false,
            offerCode: "",
            orderCode: "",
            orderType: "",
        });
    };

    const [orderDialogOpen, setOrderDialogOpen] = useState<boolean>(false);
    const handleClickOrder = async () => {
        setProgressPopupOpen(true);
        if (parts && details) {
            var availabilitParts =
                trackingOfferHook.mapPartsToAvailabilityItems(parts);

            var _avaibilityList: any =
                await ServiceProvider.Basket.getAvailability(
                    brand,
                    availabilitParts
                )
                    .then((response: AvailabilityPartResponseDTO[]) => {
                        setItemsForOrder(
                            trackingOfferHook.mapPartsToOrderItems(
                                parts,
                                response
                            )
                        );
                        setPricesForOrder(
                            trackingOfferHook.mapDetailsToOrderPrices(details)
                        );

                        setPropsForOrder(
                            trackingOfferHook.getPropsForOrder(details)
                        );
                        setOrderDialogOpen(true);
                        setProgressPopupOpen(false);
                    })
                    .catch((error) => {
                        console.error(error);
                        setProgressPopupOpen(false);
                    });
        }
    };
    const handleCloseOrderDialog = () => {
        setOrderDialogOpen(false);
    };

    var timeout: NodeJS.Timeout;

    const handleChangePage = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        if (timeout !== undefined) clearTimeout(timeout);
        setPage(page);
    };

    useEffect(() => {
        timeout = setTimeout(() => {
            fetchData();
        }, 1500);
    }, [page]);

    return (
        <Root>
            <BreadcrumbComponent />

            <Container>
                <PageTitle>
                    <AppIconsOrderOffer /> {t("common.orderOffer.titlePage")}
                </PageTitle>
                <Content>
                    <CreateBasketDialog
                        name={""}
                        open={createDialogOpen}
                        onClose={(val: boolean) => {
                            setCreateDialogOpen(false);
                        }}
                        onCreate={handleCreateBasketConfirm}
                    />
                    <Dialog
                        id="dialog-basket"
                        aria-labelledby="dialog-title"
                        open={existingDialogOpen}
                        onClose={() => setExistingDialogOpen(false)}
                    >
                        <DialogTitleStyled>
                            <div>{t("common.spareparts.selectBasket")}</div>
                            <IconButton
                                onClick={() => setExistingDialogOpen(false)}
                            >
                                <AppIconsClose />
                            </IconButton>
                        </DialogTitleStyled>
                        <DialogContentStyled>
                            <List>
                                {basketsList.map((basket: Basket) => (
                                    <MenuItem
                                        key={basket.id}
                                        onClick={() =>
                                            handleBasketSelect(basket)
                                        }
                                    >
                                        <Box>
                                            <Typography
                                                fontSize="0.70rem"
                                                display="block"
                                                variant="caption"
                                            >
                                                {basket.creationDate && (
                                                    <>
                                                        {formatDateByLocale(
                                                            basket.creationDate,
                                                            currentLanguage
                                                        )}
                                                    </>
                                                )}
                                            </Typography>
                                            <Typography
                                                fontSize="inherit"
                                                display="block"
                                            >
                                                {basket.name}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                ))}
                            </List>
                        </DialogContentStyled>
                    </Dialog>

                    <StyledCommonDialog
                        open={dialogProps.open}
                        closeDialog={handleDialogClose}
                        useConfirmBtn={
                            !dialogLoading &&
                            trackingOfferHook.isOffer(value) &&
                            trackingOfferHook.isOrderable(details) &&
                            currentSite.permissions?.canSubmitAnOrder
                        }
                        disableConfirmBtn={
                            !dialogLoading &&
                            trackingOfferHook.isOffer(value) &&
                            !trackingOfferHook.isOrderable(details)
                        }
                        useDenyBtn={false}
                        denyButton={handleDialogClose}
                        denyButtonText={"common.close"}
                        confirmButton={handleClickOrder}
                        confirmButtonText={"orderoffer.convert_ofo"}
                        dialogTitleLabel={
                            value === 0
                                ? "orderoffer.orderDetails"
                                : "orderoffer.offerDetails"
                        }
                        dialogExtraTitleLabel={
                            details?.customerReference &&
                            " - " + details?.customerReference
                        }
                        maxWidth={"lg"}
                        MoreComponent={() => (
                            <OrderOfferAddPartsToBasket
                                details={dialogProps}
                                onAddToExistingCart={handleAddToExistingCart}
                                onAddToNewCart={handleAddToNewCart}
                            />
                        )}
                    >
                        <>
                            <OfferOrderDetailsPage
                                details={details}
                                parts={parts}
                                loading={dialogLoading}
                            />
                            <BasketOfferOrderDialog
                                open={orderDialogOpen}
                                onClose={handleCloseOrderDialog}
                                prices={pricesForOrder}
                                items={itemsForOrder}
                                currency={!loading ? details?.currency : "-"}
                                showDiscount={true}
                                typeSubmit={"ORDER_FROM_OFFER"}
                                propsForOrder={propsForOrder}
                            />
                        </>
                    </StyledCommonDialog>
                    <Tabs
                        onChange={handleChange}
                        value={customerCode && value >= 0 ? value : false}
                        sx={classes.tabs}
                    >
                        <Tab
                            value={0}
                            sx={classes.tab}
                            icon={<AppIconsOrder />}
                            iconPosition="start"
                            label={t("orderoffer.orders")}
                            disabled={!orderHistoryEnabled}
                        />
                        <Tab
                            value={1}
                            sx={classes.tab}
                            icon={<AppIconsOffer />}
                            iconPosition="start"
                            label={t("orderoffer.offers")}
                            disabled={!offerHistoryEnabled}
                        />
                    </Tabs>
                    <OrderOfferHistoryFilter
                        filters={filters}
                        tabValue={value}
                        updateFilters={updateFilters}
                        isFetching={loading}
                        accordionExpanded={accordionExpanded}
                        setAccordionExpanded={setAccordionExpanded}
                        isOrder={value === 0}
                    />
                    <TabsComponentStyled
                        className={
                            accordionExpanded
                                ? value === 0
                                    ? "filtersOpened_orders"
                                    : "filtersOpened_offers"
                                : ""
                        }
                    >
                        <AppCustomTabPanel
                            className={"orders"}
                            value={value}
                            index={0}
                        >
                            <PartList
                                items={orders}
                                loading={loading}
                                columns={getColumns(value)}
                                onOfferOrderRowClick={
                                    handleOpenOfferOrderDetails
                                }
                            />
                        </AppCustomTabPanel>
                        <AppCustomTabPanel
                            className={"offers"}
                            value={value}
                            index={1}
                        >
                            <PartList
                                items={offers}
                                loading={loading}
                                columns={getColumns(value)}
                                onOfferOrderRowClick={
                                    handleOpenOfferOrderDetails
                                }
                            />
                        </AppCustomTabPanel>
                    </TabsComponentStyled>
                    <Box>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handleChangePage}
                            disabled={loading}
                            color={"primary"}
                        />
                    </Box>
                    {/* <CommonSnackbar
                        isError={basketActionResultSnackbarState.isError}
                        message={basketActionResultSnackbarState.message}
                        onClose={() => {
                            setBasketActionResultSnackbarState({
                                ...basketActionResultSnackbarState,
                                open: false,
                            });
                        }}
                        open={basketActionResultSnackbarState.open}
                    /> */}
                    <ProgressPopup
                        open={progressPopupOpen}
                        label={"offerOrder.statusType.inpreparation"}
                    />
                </Content>
            </Container>
        </Root>
    );
};

export default OfferOrderPage;